import { render, staticRenderFns } from "./WorkIndMan.vue?vue&type=template&id=600c4eb0&scoped=true&"
import script from "./WorkIndMan.vue?vue&type=script&lang=js&"
export * from "./WorkIndMan.vue?vue&type=script&lang=js&"
import style0 from "./WorkIndMan.vue?vue&type=style&index=0&id=600c4eb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c4eb0",
  null
  
)

export default component.exports